import { Link } from "react-router-dom";
import { Card, CardBody, CardHeader, EmptyState, ErrorState, LoadingState } from "@odingard/design-system";
import { useAuth } from "../../lib/auth";
import { useAsync } from "../../lib/useAsync";
import { meetingApi } from "../../lib/api";
import { WorkItemLabel } from "./MeetingShared";

export function MeetingWorkItems() {
  const { activeOrg } = useAuth();
  const request = useAsync(() => meetingApi.workItems(activeOrg?.id ?? ""), [activeOrg?.id]);
  if (request.loading) return <LoadingState label="Loading governed work items…" />;
  if (request.error) return <ErrorState description={request.error.message} onRetry={request.reload} />;
  const items = request.data?.data.items ?? [];
  if (items.length === 0) return <EmptyState title="No open Meeting AI work" description="Nothing is awaiting governed action." />;
  return (
    <Card>
      <CardHeader title="Meeting AI governed work" />
      <CardBody>
        {items.map((item) => {
          const path = item.subjectType === "meeting"
            ? `/studio/meeting-ai/meetings/${item.subjectId}`
            : `/studio/meeting-ai/commitments/${item.subjectId}`;
          return <p key={`${item.workItemType}:${item.subjectId}`}><Link to={path}><WorkItemLabel type={item.workItemType} /></Link></p>;
        })}
      </CardBody>
    </Card>
  );
}
